"use client";

import { useState, useEffect } from "react";
import { notFound } from "next/navigation";
import ENDPOINTS from "@/lib/endpoints";
import { request } from "@/lib/helpers";

export default function useBlogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      try {
        const { data } = await request.get(
          `${ENDPOINTS.BLOGS}?page=${currentPage}`
        );

        if (!data || !data.data.blogs) {
          return notFound();
        }

        setBlogs(data.data.blogs.data); // Paginated blog data
        setPagination(data.data.blogs);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, [currentPage]);

  return { blogs, loading, pagination, setCurrentPage };
}
